import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import Grid from '@material-ui/core/Grid';
import { toast } from 'react-toastify';
import CompanyModalUpdate from '../../modal/companyUpdate';
import CompanyModal from '../../modal/companyModal';
import { ShowNotification } from '../../../Notifications';
import database from '../../../../model/firebase/firebase';
import DownloadCompaniesReport from '../../excel/companies';
import { fetchDataPostAsync } from '../../../../model/axios/fetchs';

const MainContainer = styled.main`
  .ac-titles {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
  }
  .ac-search-place {
    font-size: 1.2rem !important;
    display: block;
    font-weight: 400;
    margin-top: 12px;
    margin-bottom: 8px;
  }
  .ac-search-input {
    background-color: #f6faf9;
    font-family: 'Sofia Pro', sans-serif;
    font-size: 16px;
    border-radius: 30px;
    width: 80%;
    padding: 8px 32px;
  }
  .company-list {
    margin-top: 32px;
  }
  .ac-search-title {
    font-size: 2rem !important;
    line-height: 1.7;
    padding-bottom: 24px;
    color: #232323;
    font-family: 'Cooper Md BT', serif;
  }
  .ac-company-item {
    position: relative;
    background: #e9e9e9;
    border: 0 solid rgba(0, 0, 0, 0.125);
    border-radius: 0.2rem;
    box-shadow: 0 5px 20px 0 rgb(0 0 0 / 15%);
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    transition: all ease-in-out 1s;
    transform: translateY(0);
    a {
      text-decoration: none !important;
      user-select: none;
      &:hover {
        cursor: pointer;
      }
    }
    p {
      color: #232323 !important;
      font-size: 16px !important;
      line-height: 1.7;
      margin-bottom: 8px;
    }
    h1 {
      font-size: 20px !important;
    }
    .company-bg {
      position: relative;
      display: block;
      height: 250px;
      width: 100%;
      overflow: hidden;
      flex: 0 0 auto;
    }
    .company-content {
      background-color: #fff;
      position: relative;
      display: flex;
      flex-direction: column;
      flex: 1 1 auto;
      padding: 0 16px;
    }
    .company-base {
      position: relative;
      z-index: 2;
      background-color: #fff;
      padding: 64px 16px 24px 16px;
      flex: 0 0 auto;
      h3 {
        font-size: 24px !important;
        color: #0d5c1d;
        font-family: 'Cooper Md BT', serif;
        margin-top: 12px;
        text-transform: capitalize;
        margin-bottom: 12px;
        line-height: 1.7;
      }
      h4 {
        font-family: 'Sofia Pro', sans-serif;
        letter-spacing: 1px;
        font-weight: 400;
        font-size: 16px;
      }
    }
    .company-logo {
      display: block;
      background-color: #fff;
      box-shadow: rgb(0 0 0 / 8%) 0px 3px 10px;
      margin-right: 16px;
      position: absolute;
      top: -75px;
      left: 0;
      width: 100px;
      height: 100px;
      flex: 0 0 auto;
      border-radius: 8px;
      overflow: hidden;
      padding: 4px;
      img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
      }
    }
  }
  .ac-company-icon {
    width: 100%;
    display: block;
    height: auto;
  }
  .ac-icon-side {
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ac-info-side-jl {
    width: 25%;
    padding-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .ac-info-side-jl-action {
    width: 26%;
    padding-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ac-info-side-jl-watch {
    width: 17%;
    padding-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .ac-update-access {
    display: block;
    font-size: 1.2rem;
    border: none;
    padding-left: 15px;
    padding-right: 15px;
    border-radius: 4px;
    width: 100%;
    margin-top: 18px;
  }
  .ac-update-access:hover {
    display: block;
    font-size: 1.3rem;
    padding-left: 15px;
    padding-right: 15px;
    color: var(--white-color);
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    border-radius: 4px;
  }
  .update-modal-input {
    background-color: #f6faf9;
    font-family: 'Sofia Pro', sans-serif;
    font-size: 16px;
    border-radius: 30px;
    width: 80%;
    padding: 8px 32px;
    margin-bottom: 12px;
  }
  .update-modal-label {
    font-size: 1rem;
    margin-bottom: 5px;
    margin-top: 10px;
    margin-left: 4px;
  }
  .modal-update-company {
    width: 500px;
    padding: 25px;
  }
  .update-modal-button-update {
    display: inline-block;
    font-size: 1.4rem;
    border-radius: 32px;
    background-color: ${(props) => (props.adminColor ? props.adminColor : '#0f3f44')};
    color: white;
    padding-left: 20px;
    padding-right: 20px;
  }
  .update-modal-button-cancel {
    display: inline-block;
    font-size: 1.4rem;
    border-radius: 32px;
    background-color: #b00020;
    color: white;
    padding-left: 20px;
    padding-right: 20px;
    margin-left: 12px;
  }
  .update-modal-title {
    width: 90%;
    font-size: 2.2rem;
    text-transform: capitalize;
    font-family: 'Cooper Md BT', serif;
    font-weight: 500;
    margin-top: 8px;
    margin-bottom: 20px;
  }
  .update-modal-buttons {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin-top: 50px;
    margin-bottom: 10px;
    align-items: center;
    width: 50%;
    padding: 0 12px;
    margin-right: auto;
    margin-left: auto;
  }
  .mt-update-modal {
    margin-top: 30px;
  }
  .mc-name {
    font-size: 1.8rem;
    font-weight: 700;
  }
  .k-button {
    border-color: #0f3f44;
    color: #ffffff;
    background-color: #0f3f44;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.04));
    padding: 8px 16px;
    justify-self: end;
    border-radius: 32px;
    align-self: end;
    &:hover {
      border-color: #fcd7e0;
      background-color: #fcd7e0;
    }
  }
  .k-dialog-titlebar {
    background-color: #0f3f44;
  }
`;
const ManageCompanies = () => {
  const [state, setState] = React.useState({
    companies: [],
    renderModal: false,
    renderExport: false,
    showModal: false,
    companyName: '',
    email: '',
    password: '',
    uid: '',
    loading: false,
    oldEmail: '',
    currentCompanyData: {},
    open: false,
  });

  const [confirm, setConfirm] = React.useState({
    email: '',
    id: '',
    company: '',
  });

  const { platform } = useSelector((state) => state);
  const { companies } = useSelector((state) => state);

  const bodyMailNotification = () =>
    platform.customEmails
      ? {
          fromEmail: `${platform.fromEmail}`,
          destiny: `${state.email}`,
          subject: `${state.companyName} actualización exitosa para la bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola,</p>
            <br />
            <p style="font-size: 18px;">Ya puedes publicar vacantes ilimitadas accediendo al
             portal ${platform.platformURL} con el usuario <strong>${state.email}</strong> y 
             la contraseña <strong>${state.password}</strong>.</p>
             <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el uso o la plataforma puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
             <p style="font-size: 18px;">Te deseamos mucho éxito y esperamos encuentres 
             colaboradores que encajen con tu compañía.</p>
             <br />
             <img width="160px" src=${platform.customEmailsLogo} />
              <br />
              <p style="font-size: 14px;">¿Ya nos sigues?</p>
              <br />
              ${
                platform.facebookLink &&
                `<a styles="margin: 7px" href=${platform.facebookLink}>
                    <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png"/>
                   </a>`
              }
              ${
                platform.twitterLink &&
                `<a styles="margin: 7px" href=${platform.twitterLink}>
                    <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png"/>
                   </a>`
              }
            ${
              platform.instagramLink &&
              `<a styles="margin: 7px" href=${platform.instagramLink}>
                    <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png"/>
                  </a>`
            }
            ${
              platform.linkedinLink &&
              `<a styles="margin: 7px" href=${platform.linkedinLink}>
                  <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png"/>
                </a>`
            }
            `,
        }
      : {
          destiny: `${state.email}`,
          subject: `${state.companyName} actualización exitosa para la bolsa de trabajo de ${platform.platformName}`,
          body: `<p style="font-size: 18px; font-weight: 600;">Hola,</p>
            <br />
            <p style="font-size: 18px;">Ya puedes publicar vacantes ilimitadas accediendo al
             portal ${platform.platformURL} con el usuario <strong>${state.email}</strong> y 
             la contraseña <strong>${state.password}</strong>.</p>
             <br />
             <p style="font-size: 18px;">Si tiene dudas sobre el uso o la plataforma puedes contactarte
              con el administrador: ${platform.platformContact}.</p>
            <br />
             <p style="font-size: 18px;">Te deseamos mucho éxito y esperamos encuentres 
             colaboradores que encajen con tu compañía.</p>
             <br />
            <img width="140px" src="https://firebasestorage.googleapis.com/v0/b/universia-prod.appspot.com/o/defaultImages%2Flogo-dark.37c08620.png?alt=media&token=b1c8657c-4e50-404f-8736-ae15aa0bdd29" />
            <br />
            <p style="font-size: 14px;">¿Ya nos sigues?</p>
            <br />
            <a styles="margin: 7px" href="https://www.facebook.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://cdn.iconscout.com/icon/free/png-512/facebook-logo-2019-1597680-1350125.png">
            </a>
            <a styles="margin: 7px" href="https://twitter.com/lapiezaio?lang=es">
                <img styles="margin: 8px" width="40px" src="https://cdn.icon-icons.com/icons2/1183/PNG/512/1490133460-social-icons01_82210.png">
            </a>
            <a styles="margin: 7px" href="https://www.instagram.com/lapieza.io/">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137380/isolated/preview/1b2ca367caa7eff8b45c09ec09b44c16-icono-de-instagram-logo-by-vexels.png">
            </a>
            <a styles="margin: 7px" href="https://ar.linkedin.com/company/lapieza">
                <img styles="margin: 8px" width="40px" src="https://images.vexels.com/media/users/3/137382/isolated/preview/c59b2807ea44f0d70f41ca73c61d281d-icono-de-linkedin-logo-by-vexels.png">
            </a>`,
        };

  const searchType = (e) => {
    const query = e.target.value;
    setState((prev) => ({
      ...prev,
      companies: companies
        .filter((company) => {
          const locationName = company.locationName.toLowerCase().includes(query.toLowerCase());
          const companyName = company.companyName.toLowerCase().includes(query.toLowerCase());
          const email = company.companyEmail.toLowerCase().includes(query.toLowerCase());
          return locationName || companyName || email;
        })
        .sort((a, b) => {
          return a.names < b.names;
        }),
    }));
  };

  const updateCompany = (data) => {
    setState((prev) => ({
      ...prev,
      renderModal: true,
      showModal: true,
      email: data.companyEmail,
      oldEmail: data.companyEmail,
      uid: data.objectID,
      companyName: data.companyName,
      loading: false,
    }));
  };

  const watchCompany = (data) => {
    setState((prev) => ({
      ...prev,
      idCurrentCompany: data.objectID,
      renderModalCompany: true,
      showModalCompany: true,
      currentCompanyData: data,
    }));
  };

  const sendUpdate = async () => {
    setState((prev) => ({
      ...prev,
      loading: true,
    }));
    const { email, password, oldEmail, uid } = state;
    const sendable = {
      email,
      password,
      oldEmail,
      update: true,
    };
    await fetchDataPostAsync('company-register', sendable);
    await database.collection(`${platform.platformName}/data/companies`).doc(uid).update({ companyEmail: email });
    setState((prev) => ({
      ...prev,
      loading: false,
      showModal: false,
    }));
    await fetchDataPostAsync('sendEmailHTML', bodyMailNotification());
    toast.success('Credenciales actualizadas.');
  };

  const deleteCompany = async (email, id, company) => {
    setState((prev) => ({
      ...prev,
      renderExport: false,
    }));
    await fetchDataPostAsync('rejectUser', { email });
    await database.collection(platform.platformName).doc('data').collection('deletedCompanies').doc(id).set(company);
    await database.collection(platform.platformName).doc('data').collection('companies').doc(id).delete();
    ShowNotification('success', 'Se eliminó correctamente a la empresa', '¡Listo!');
    const newCompanies = companies.filter((company) => company.objectID !== id);
    setState((prev) => ({
      ...prev,
      companies: newCompanies,
      renderExport: true,
    }));
  };

  const confirmDelete = (email, id, company) => {
    setState((prev) => ({
      ...prev,
      open: true,
    }));
    setConfirm({
      email,
      id,
      company,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const ToggleModal = () => {
    setState((prevState) => ({
      ...prevState,
      showModal: !prevState.showModal,
      renderModal: !prevState.renderModal,
      password: '',
      companyEmail: '',
      uid: '',
    }));
  };

  const ToggleModalCompany = () => {
    setState((prevState) => ({
      ...prevState,
      showModalCompany: !prevState.showModalCompany,
      renderModalCompany: !prevState.renderModalCompany,
    }));
  };

  const closedConfirm = () => {
    setState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  React.useEffect(() => {
    setState((prev) => ({
      ...prev,
      companies,
      renderExport: true,
    }));
  }, []);

  return (
    <MainContainer adminColor={platform?.adminColor}>
      <div className="container height-100">
        <Grid container className="a-main-card">
          <Grid item lg={5}>
            <h1 className="ac-search-title">Empresas registradas actualmente</h1>
          </Grid>
          <Grid item lg={5}>
            {/* <label htmlFor="searchBox" className="ac-search-place"> */}
            {/*  Búsqueda rápida */}
            {/* </label> */}
            <input
              type="text"
              id="searchBox"
              placeholder="Ejemplo: Mercado libre"
              className="ac-search-input"
              onChange={searchType}
            />
          </Grid>
          <Grid item lg={2} className="AdminUsersTtiles">
            {state.renderExport ? (
              <DownloadCompaniesReport filename="ResumenEmpresas" button companiesDataSet={state.companies} />
            ) : null}
          </Grid>
          <Grid container spacing={3} className="company-list">
            {state.companies.map((company) => {
              if (company.active) {
                return (
                  <Grid item xl={4} lg={6} md={6} key={company.objectID}>
                    <article className="ac-company-item">
                      <img
                        src="https://lapieza-unis-admin-test.s3.us-west-1.amazonaws.com/static/media/abstract-b.d5fe6544.jpg"
                        alt=""
                        className="company-bg"
                      />

                      <div className="company-content">
                        <div className="company-base">
                          <div className="company-logo">
                            <img
                              src={
                                company.companyLogo === ''
                                  ? 'https://firebasestorage.googleapis.com/v0/b/lapieza-production.appspot.com/o/imgDefault%2Fnegocio.png?alt=media&token=0e43774b-31b8-4393-bbe3-a6492da45174'
                                  : company.companyLogo
                              }
                              alt=""
                            />
                          </div>
                          <h3>{company.companyName}</h3>
                          <h4>Administrado por: {company.adminName}</h4>
                          <p>{company.locationName} - </p>
                          <p>{company.companyEmail}</p>
                          <Grid container spacing={2}>
                            <Grid item lg={4}>
                              <button
                                type="button"
                                className="ac-update-access"
                                onClick={() => {
                                  updateCompany(company);
                                }}>
                                Actualizar
                              </button>
                            </Grid>
                            <Grid item lg={4}>
                              <button
                                type="button"
                                className="ac-update-access"
                                onClick={() => {
                                  confirmDelete(company.companyEmail, company.objectID, company);
                                }}>
                                Eliminar
                              </button>
                            </Grid>
                            <Grid item lg={4}>
                              <button
                                type="button"
                                className="ac-update-access"
                                onClick={() => {
                                  watchCompany(company);
                                }}>
                                Ver más
                              </button>
                            </Grid>
                          </Grid>
                        </div>
                      </div>
                    </article>
                  </Grid>
                );
              }
            })}

            {state.companies.length === 0 ? <p className="no-results">No hay resultados para esta búsqueda</p> : null}
          </Grid>
        </Grid>
        {state.renderModal ? (
          <CompanyModalUpdate
            open={state.showModal}
            handleInputChange={handleInputChange}
            email={state.email}
            password={state.password}
            companyName={state.companyName}
            close={ToggleModal}
            done={sendUpdate}
            message={state.loading}
          />
        ) : null}
        {state.renderModalCompany ? (
          <CompanyModal
            open={state.showModalCompany}
            close={ToggleModalCompany}
            data={state.currentCompanyData}
            id={state.idCurrentCompany}
          />
        ) : null}
      </div>
      {state.open ? (
        <Dialog title="" onClose={closedConfirm}>
          <div className="custom-ui">
            <p className="job-title">
              Al eliminarla la empresa perderá acceso a la plataforma <br /> y no podrá eliminar, editar o agregar mas
              vacantes.
            </p>
            <p className="text">¿Estás segura de que deseas eliminar empresa?</p>
            <DialogActionsBar>
              <button type="button" className="k-button" onClick={closedConfirm}>
                No
              </button>
              <button
                type="button"
                className="k-button"
                onClick={() => {
                  deleteCompany(confirm.email, confirm.id, confirm.company);
                  closedConfirm();
                }}>
                Yes
              </button>
            </DialogActionsBar>
          </div>
        </Dialog>
      ) : null}
    </MainContainer>
  );
};

export default ManageCompanies;
